import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getMeasurementsForSiteInArrowOptions } from "../../../services/client/@tanstack/react-query.gen";
import { tableFromIPC } from "@uwdata/flechette";
import { TimeSeries, TimeSeriesChart } from "../Charts/TimeSeriesChart";
import {
  extrapolateToTimeseries,
  generateCommonTimeline,
  parseArrowToTimeSeries,
} from "./dataUtils";
import { ONE_HOUR } from "../../../util/time";
import { sortBy } from "lodash";

type MeasurementsArrowChartProps = {
  site_id: string;
};

export const MeasurementsArrowChart: React.FC<MeasurementsArrowChartProps> = ({
  site_id,
}) => {
  const TWELVE_HOURS_AGO = new Date(Date.now() - 12 * ONE_HOUR);
  const SIX_HOURS_FROM_NOW = new Date(Date.now() + 6 * ONE_HOUR);

  const [timeSeries, setTimeSeries] = useState<TimeSeries[]>();

  const [from] = useState(TWELVE_HOURS_AGO);
  const [to] = useState(SIX_HOURS_FROM_NOW);

  const { data, isLoading, error } = useQuery({
    ...getMeasurementsForSiteInArrowOptions({
      path: { site_id },
      query: { start: from.toISOString(), stop: to.toISOString() },
    }),
  });

  useEffect(() => {
    async function fetchData() {
      if (!data) {
        return;
      }
      const arrayBuffer = await (data as Response).arrayBuffer();
      const table = tableFromIPC(arrayBuffer, { useProxy: true }).toArray();
      const parsedData = parseArrowToTimeSeries(table);

      const commonTimestamps = generateCommonTimeline(parsedData);
      const alignedSeries = parsedData.map((series) =>
        extrapolateToTimeseries(series, commonTimestamps),
      );

      setTimeSeries(sortBy(alignedSeries, "name"));
    }
    fetchData();
  }, [data]);

  return (
    <TimeSeriesChart
      data={timeSeries}
      title="arrow"
      className="w-full"
      line="smooth"
      isLoading={isLoading}
      error={error}
    />
  );
};
